export default __webpack_public_path__ + "static/media/property_345.39b1545d.png";